// src/components/NewsletterForm.js
// Shared newsletter subscribe form — used on the homepage CTA band, the
// footer, and the site-wide popup modal. Posts to /api/newsletter/subscribe.
import React, { useState } from "react";
import { subscribeToNewsletter } from "../utils/newsletterApi";

function NewsletterForm({ source = "unknown", labelClassName = "", compact = false }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setStatus("submitting");
    setMessage("");

    try {
      await subscribeToNewsletter(email.trim(), source);
      setStatus("success");
      setMessage("You're subscribed. Thanks for staying connected!");
      setEmail("");
    } catch (err) {
      setStatus("error");
      setMessage(err.message);
    }
  };

  if (status === "success") {
    return (
      <div className={labelClassName} style={{ fontWeight: 600 }}>
        {message}
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} aria-label="Newsletter subscription">
      {!compact && (
        <label className={`form-label fw-semibold ${labelClassName}`} htmlFor={`newsletter-email-${source}`}>
          Subscribe to our newsletter
        </label>
      )}
      <div className="d-flex flex-column flex-sm-row gap-2">
        <label className="visually-hidden" htmlFor={`newsletter-email-${source}`}>
          Email address
        </label>
        <input
          id={`newsletter-email-${source}`}
          type="email"
          required
          placeholder="Enter your email address"
          className="form-control"
          aria-label="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ borderRadius: 14, minHeight: 52, border: "none" }}
        />
        <button
          type="submit"
          disabled={status === "submitting"}
          className="btn fw-semibold px-4"
          style={{
            borderRadius: 14,
            minHeight: 52,
            background: "var(--ibg-ink)",
            color: "var(--ibg-white)",
            border: "none",
            whiteSpace: "nowrap",
          }}
        >
          {status === "submitting" ? "Subscribing..." : "Subscribe"}
        </button>
      </div>
      {status === "error" ? (
        <div className="mt-3" style={{ fontSize: "0.92rem", color: "#ffb4a8" }} role="alert">
          {message}
        </div>
      ) : (
        <div className="mt-3" style={{ fontSize: "0.92rem", color: "var(--ibg-tint)" }}>
          Relevant updates. No noise.
        </div>
      )}
    </form>
  );
}

export default NewsletterForm;
